import {
  ActionIcon,
  Anchor,
  Box,
  Button,
  Grid,
  Group,
  Input,
  Select,
  Switch,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconEdit,
  IconPlus,
  IconSearch,
  IconTimeDuration15,
  IconTrash,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import CreateView from "./CreateView";
import DeleteView from "./DeleteView";
import EditView from "./EditView";
import UpdateOrderNumberView from "./updateorderNumberView";
import { repositoryWeb } from "../../../_base/_const/_constVar";
interface SearchCriteria {
  keySearch?: string;
  status?: string;
  location?: string;
  ArticleCategoryId: string;
}

const ArticleReward = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<any[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const optionSearch = {
    isActive: [
      {
        value: "2",
        label: "Bản nháp",
        "data-test-subj": "titanOption",
      },
      {
        value: "1",
        label: "Đã duyệt",
        "data-test-subj": "titanOption",
      },
      {
        value: "0",
        label: "Chờ duyệt",
      },
    ],
  };
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {
      keySearch: _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
      status: _searchJson && checkedPinSearch ? _searchJson?.status : "",
      location: _searchJson && checkedPinSearch ? _searchJson?.location : "",
      ArticleCategoryId: "60",
    },
  });

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "thumnail",
        header: "Ảnh ",
        size: 135,
        Cell: ({ row }) => {
          const url = row.original.thumnail;
          if (!url) return null;
          return (
            <img
              src={url}
              alt={row.original.title}
              style={{ width: "80px", height: "60px", objectFit: "contain" }}
            />
          );
        },
      },
      {
        accessorKey: "title",
        header: "Tiêu đề",
        size: 300,
      },

      {
        accessorKey: "url",
        header: "Đường dẫn",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        size: 135,
        Cell: ({ row }) => (
          <Anchor href={row.original.url} target="_blank" underline="hover">
            Xem trang bài viết
          </Anchor>
        ),
      },
      {
        accessorKey: "summary",
        header: "Nội dung",
        size: 250,
        Cell: ({ row }) => <Text>{row.original.summary}</Text>,
      },
      // {
      //   accessorKey: "ordering",
      //   header: "Thứ tự",
      //   size: 120,
      //   Cell: ({ row }) => {
      //     return (
      //       <Anchor
      //         fw={500}
      //         c="blue"
      //         ml={10}
      //         underline="hover"
      //         style={{ cursor: "pointer" }}
      //         onClick={() => {
      //           const id = row.original.id;
      //           const orderNumber = row.original.ordering;
      //           console.log("data test", data);
      //           modals.openConfirmModal({
      //             title: (
      //               <>
      //                 <div color="white">
      //                   <Title order={5}>Cập nhật STT !</Title>
      //                 </div>
      //               </>
      //             ),
      //             children: (
      //               <UpdateOrderNumberView
      //                 onSearch={() => fetchData()}
      //                 id={id}
      //                 orderNumber={orderNumber ?? 0}
      //                 data={row.original}
      //               />
      //             ),
      //             confirmProps: { display: "none" },
      //             cancelProps: { display: "none" },
      //           });
      //         }}
      //       >
      //         {row.original.ordering}
      //       </Anchor>
      //     );
      //   },
      // },
      {
        accessorKey: "postedDate",
        header: "Ngày đăng tải",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="sm">
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      // {
      //   accessorKey: "visit",
      //   header: "Lượt xem",
      //   size: 135,
      //   Cell: ({ row }) => (
      //     <Text fw={500} c="#FF0000" ml={10}>
      //       {row.original.visit}
      //     </Text>
      //   ),
      // },
      // {
      //   accessorKey: "likeCount",
      //   header: "Lượt thích",
      //   size: 135,
      // },
      // {
      //   accessorKey: "commentCount",
      //   header: "Lượt bình luận",
      //   size: 135,
      // },
      // {
      //   accessorKey: "reviewCount",
      //   header: "Lượt đánh giá",
      //   size: 135,
      // },
      {
        accessorKey: "status",
        header: "Trạng thái",
        size: 135,
        Cell: ({ row }) => (
          <>
            <Switch
              checked={row.original.status === 1}
              color="blue"
              size="xs"
              mr={3}
              onClick={async (e: any) => {
                open();
                await featuredActive(row.original.id, "status");
              }}
            />
            <Text>
              {" "}
              {row.original.status === 1
                ? "Hoạt động"
                : row.original.status === 2
                ? "Bản nháp"
                : "Chờ duyệt"}
            </Text>
          </>
        ),
      },
      // {
      //   accessorKey: "isStricking",
      //   header: "Nổi bật",
      //   size: 135,
      //   Cell: ({ row }) => (
      //     <>
      //       <Switch
      //         checked={row.original.isStricking === "Y"}
      //         color="blue"
      //         size="xs"
      //         mr={3}
      //         onClick={async (e: any) => {
      //           open();
      //           await featuredActive(row.original.id, "priority");
      //         }}
      //       />
      //       <Text>
      //         {" "}
      //         {row.original.isStricking === "Y" ? "Tắt nổi bật" : "Mở nổi bật"}
      //       </Text>
      //     </>
      //   ),
      // },
      {
        accessorKey: "lastUpdateDate",
        header: "Ngày cập nhật",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "lastUpdatedBy",
        header: "Người cập nhật",
      },
      {
        accessorKey: "action",
        header: "Thao tác ",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 135,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                color="yellow"
                onClick={() => {
                  editItem(row.original.id);
                }}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                color="red"
                onClick={async () => {
                  await deleteItem([row.original.id]);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    []
  );

  const modalCreateArticleReward = () =>
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm mới bài viết</Title>
          </div>
        </>
      ),
      size: "auto",
      children: <CreateView onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });

  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa bài viết</Title>
        </>
      ),
      children: <DeleteView onSearch={() => fetchData()} idItem={idItem} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa bài viết!</Title>
        </>
      ),

      children: <EditView id={id} onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  }

  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

    try {
      const search = form.getValues();

      const queryParams = new URLSearchParams();

      if (search && search.keySearch) {
        queryParams.append("KeySearch", search.keySearch);
      }
      if (search && search.status) {
        queryParams.append("Status", search.status);
      }
      if (search && search.location) {
        queryParams.append("ArticleCategoryId", search.location);
      }
      if (pagination) {
        queryParams.append(
          "Skip",
          String(pagination.pageIndex * pagination.pageSize)
        );
        queryParams.append("Take", String(pagination.pageSize));
      }

      const url = `?${queryParams.toString()}`;
      const response = await repositoryWeb.get(`/TblArticlePos/get-list${url}`);
      if (response) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify(form.getValues())
      );
    }
  };

  const featuredActive = async (id: number, type: string, order?: number) => {
    if (id < 1) NotificationExtension.Fails("Mã danh mục không tồn tại !");
    else {
      setIsLoading(true);
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      try {
        let callapi = await repositoryWeb.post<MessageResponse<boolean>>(
          `/TblArticlePos/edit-status?id=${id}`
        );
        close();
        if (isNullOrUndefined(callapi)) {
          NotificationExtension.Fails(
            "Thao tác không thành công, xin vui lòng thử lại !"
          );
        } else {
          if (callapi?.success) {
            NotificationExtension.Success("Thao tác thành công !");
            await fetchData();
          } else NotificationExtension.Fails("Thao tác thất bại !");
        }
        return callapi?.data;
      } catch (error: any) {
        throw new Error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    const productDataStr = localStorage.getItem("hacom_edit_product");
    if (productDataStr) {
      try {
        const productData = JSON.parse(productDataStr);
        if (
          productData.openModal &&
          productData.type === "edit" &&
          productData.id
        ) {
          editItem(productData.id);
          localStorage.removeItem("hacom_edit_product");
        }
      } catch (e) {}
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,

    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["status", "priority", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    // mantineTableBodyCellProps: ({ row }) => ({
    //   style: styleTableMantine,
    // }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
      siblings: 1,
      boundaries: 1,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  return (
    <Box>
      <Group gap={0} justify="space-between" mb={10}>
        <BreadCrumb></BreadCrumb>
      </Group>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        {/* Thông báo thời gian đồng bộ dữ liệu lên web */}
        <Box
          style={{
            background: "#fffbe6",
            border: "1.5px solid #ffe58f",
            borderRadius: 8,
            padding: "5px",
            marginBottom: 2,
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontWeight: 600,
            color: "#ad6800",
            fontSize: 14,
          }}
        >
          <IconTimeDuration15
            size={22}
            color="#faad14"
            style={{ marginRight: 6 }}
          />
          <span>
            <b>Lưu ý:</b> Sau khi cập nhật, có thể dữ liệu sẽ được đồng bộ lên
            website trong khoảng <b>15-30 phút</b>. Vui lòng kiểm tra lại sau
            thời gian này để thấy thay đổi.
          </span>
        </Box>
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid mt={10}>
            <Grid.Col
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              <Input
                placeholder="Nhập tìm kiếm"
                key={form.key("keySearch")}
                type="text"
                leftSection={<IconSearch size={"20"} color="#15aabf" />}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
                {...form.getInputProps("keySearch")}
              />
              <Select
                placeholder="Trạng thái"
                data={optionSearch.isActive}
                key={form.key("status")}
                clearable
                {...form.getInputProps("status")}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
                maxDropdownHeight={500}
              />
              {/* <Select
                placeholder="Loại bài viết"
                data={dataArticleCategory}
                key={form.key("location")}
                clearable
                searchable
                {...form.getInputProps("location")}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
                maxDropdownHeight={500}
              /> */}
              <Button
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
          <Group>
            <Button
              mt={10}
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              onClick={() => {
                modalCreateArticleReward();
              }}
            >
              Thêm mới
            </Button>
            <Button
              mt={10}
              mr={10}
              leftSection={<IconTrash size={14} />}
              color="red"
              variant="outline"
              onClick={async () => {
                const selectedIds = Object.keys(rowSelection).map(
                  (key) => data[Number(key)].id
                );
                if (selectedIds && selectedIds.length < 1) {
                  NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                  return null;
                }
                await deleteItem(selectedIds);
              }}
            >
              Xóa (Đã chọn)
            </Button>
          </Group>
        </Box>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default ArticleReward;
